import { render } from "./DetailButtonRenderer.vue?vue&type=template&id=f212b5ec"
import script from "./DetailButtonRenderer.vue?vue&type=script&lang=js"
export * from "./DetailButtonRenderer.vue?vue&type=script&lang=js"

import "./DetailButtonRenderer.vue?vue&type=style&index=0&id=f212b5ec&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__